<template>
  <div class="page">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage"
      :page-sizes="[20, 40, 60]" :page-size="page.currtNum" layout="total, sizes, prev, pager, next, jumper"
      :total="page.getCurrtNum"></el-pagination>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
export default {
  components: {},
  props: ['page'],
  data () {
    return {};
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    }
  },
  created () { },
  mounted () { },
  methods: {
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.currtNum = val;
      this.$emit('getData');
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.$emit('getData');
    }
  }
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .el-pagination {
    white-space: break-spaces !important;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>